/* tslint:disable */
/* eslint-disable */
/**
 * Vahti API
 * Vahti vaatimustenhallintajärjestelmän API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jani.saine@tietosund.fi
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { TilaRequestPut } from './tila-request-put';

/**
 * 
 * @export
 * @interface TilaBatchRequest
 */
export interface TilaBatchRequest {
    /**
     * 
     * @type {string}
     * @memberof TilaBatchRequest
     */
    'operation'?: TilaBatchRequestOperationEnum;
    /**
     * 
     * @type {TilaRequestPut}
     * @memberof TilaBatchRequest
     */
    'data'?: TilaRequestPut;
}

/**
    * @export
    * @enum {string}
    */
export enum TilaBatchRequestOperationEnum {
    Insert = 'insert',
    Update = 'update',
    Delete = 'delete'
}


